import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.from || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back! 🎉");
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-32 pb-20 min-h-[80vh] flex items-center" data-testid="login-page">
      <div className="container-x max-w-md mx-auto">
        <div className="doodle-card p-8 bg-white">
          <div className="w-14 h-14 bg-[#FFE7F1] border-2 border-[#2D2424] rounded-full flex items-center justify-center mx-auto" style={{ boxShadow: "3px 3px 0 #2D2424" }}>
            <LogIn className="w-6 h-6 text-[#7A1F2B]" strokeWidth={2}/>
          </div>
          <h1 className="font-doodle text-4xl text-center mt-4 text-[#2D2424]">Welcome back!</h1>
          <p className="text-center text-sm font-hand text-[#5C5555] mt-1">Sign in to your account</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"
            />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full border-2 border-[#2D2424] px-4 py-3 focus:outline-none rounded-lg"
            />
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="text-center text-sm font-hand text-[#5C5555] mt-6">
            New here? <Link to="/signup" className="text-[#7A1F2B] underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
